<div class="panel-body ">
    <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
     <div class="panel-body ">
       <div class="row table-responsive">
      <table id="events-table" class="table table-condensed table-striped">
     <thead>
       <tr>
         <th id="V122c">
           <span class="field-code ">json='eventList.date'</span>
           Date <br>
           <span class="field-code ">json='eventList.time'</span> 
           Time
         </th>
         <th id="V121c">
           <span class="field-code ">json='eventList.eventDesc'</span>
             Event <br> 
           <span class="field-code ">json='eventList.typeDesc'</span>
             Type <br>
           <span class="field-code ">json='eventList.eventOutcomeDesc'</span> 
             Outcome
           </th>
         <th id="V121c">
           <span class="field-code ">json='eventList.presidingJudgeName'</span>
             Judge <br> 
           <span class="field-code ">json='eventList.courtroomCode'</span><span class="field-code ">json='eventList.coutroom'</span>
             Courtroom
           </th>
           <th>
              <span class="field-code ">json='eventList.notes'</span>
                Notes
            </th>
          </tr>
     </thead>
     <tbody *ngFor="let events of juvenileCase.getEventList(); let i = index">
       <tr >
        <td id="{{'juvenile-caseDetails-events-' + i + '-dateTime' }}">{{events.getEventDate() | date:'MM/dd/yyyy'}} <br> {{events.getEventTime()}}</td>        
        <td id="{{'juvenile-caseDetails-events-' + i + '-eventTypeOutcome'}}">{{events.getEventDescription()}} <br> {{events.getEventTypeDescription()}} <br> {{events.getEventOutcomeDescription()}}</td>        
        <td id="{{'juvenile-caseDetails-events-' + i + '-judgeCoutroom'}}">{{events.getEventJudgeName()}} <br>
          {{events.getLocationId()}}</td>        
        <td id="{{'juvenile-caseDetails-events-' + i + '-notes'}}">
            <span *ngIf="events.getEventNotes()!==''" [popover]="popTemplate" placement="left" triggers="click" outsideClick="true"><i class="glyphicon glyphicon-comment"></i></span>       
            <ng-template #popTemplate><pre [innerHtml]="events.getEventNotes()"></pre></ng-template>
          <!-- <span *ngIf="events.getEventNotes()!==''" popover='{{events.getEventNotes()}}' ><i class="glyphicon glyphicon-comment"></i></span> -->
        </td>
     </tr> <tr>

        <td colspan="4" > 
            <a (click)="showAdditionalEventsInfoFlags[i] = !showAdditionalEventsInfoFlags[i]">{{showAdditionalEventsInfoFlags[i] ? '>Hide Additional Information' : '>Show Additional Information'}}</a>
            <div *ngIf="showAdditionalEventsInfoFlags[i]" class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top" >
              <events-additional-info-view [additionalInfo]="events.getIssuesList()"></events-additional-info-view>
              
             </div>            
        </td>	  
      </tr>
    
     </tbody>
     </table>
     </div>
    </div>
   </div>
 </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/events/events.component.html